/// <amd-module name="Dashboards/DashboardView/src/components/complementary/DashboardTemplatePageProxy" />
import * as React from "react";

import { DashboardTemplatePageProps, DashboardTemplatePageState } from "Dashboards/DashboardTemplates/DashboardTemplatePage";

import { VssComponent, WrappedComponent } from "VSS/Platform/Layout";

/** Encapsulates delay-loaded Dashboard Template Page Experience */
export class DashboardTemplatePageProxy extends VssComponent<DashboardTemplatePageProps, DashboardTemplatePageState> {
    public render(): JSX.Element {
        return (
            <WrappedComponent
                wrappedType={"DashboardTemplatePage"}
                dependencies={["ms.vss-dashboards.dashboards-templates"]}
                wrappedProps={this.props}
            />
        );
    }
}
